module.exports = __webpack_public_path__ + "static/media/banner-cuid.26d7ba8b.png";